import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BookingProvider } from "@/context/BookingContext";
import LandingPage from "@/pages/LandingPage";
import AboutUs from "@/pages/AboutUs";
import OurPromise from "@/pages/OurPromise";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppWidget from "@/components/WhatsAppWidget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BookingProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/promise" element={<OurPromise />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <WhatsAppWidget />
        </BookingProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
